import React, { useState } from 'react'
import PropTypes from 'prop-types'

import SaveForLater from '@/components/SaveForLater'
import { iconsPath } from '@/config/globals'

import styles from './styles.module.scss'

const SavedForLaterSection = ({ savedForLaterItems, sitewidePromo }) => {
    const [isOpen, setIsOpen] = useState(true)

    const itemsLength = savedForLaterItems.length
    const hasItems = itemsLength > 0
    const arrow = isOpen ? 'arrow-down.svg' : 'arrow-up.svg'

    return ( <>
        {hasItems && 
            <div className={styles.cartItems} id='savedForLaterSection'>
                <h1 className={styles.savedForLaterTitle}>
                    Saved for later ({itemsLength})
                    <img src={`${iconsPath}/${arrow}`} alt="Arrow" className={styles.arrow} onClick={()=> setIsOpen(!isOpen)} />
                </h1>

                {isOpen && 
                    <>
                        <ul className={styles.itemList}>
                            {savedForLaterItems.map((item) => (
                                <li key={`save-for-later-${item.sku}`}>
                                    <SaveForLater item={item} sitewidePromo={sitewidePromo}/>
                                </li>
                            ))}
                        </ul>
                    </>
                }
            </div>
        }
    </>
    )
}

SavedForLaterSection.propTypes = {
    savedForLaterItems: PropTypes.array.isRequired,
    sitewidePromo: PropTypes.any
}

export default SavedForLaterSection
